import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=82a7d026&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports